import { cloneDeep, orderBy } from 'lodash';
import PoReconciliationDrawerTable from 'pages/PurchaseOrder/PoReconciliation/PoReconciliationDrawer';
import { currencyFormat } from 'utils/columns';

const defaultClaimsFilter = {
  currentPage: 1,
  pageSize: 10,
  order: 'desc',
  orderBy: 'ceReceivable',
  filters: [],
};
  //24-10-2024
  const defaultPOFilter = {
    currentPage: 1,
    pageSize: 10,
    order: 'desc',
    orderBy: 'poid',
    filters: [],
  };
  const defaultPOReconFilter = {
    currentPage: 1,
    pageSize: 1000,
    order: 'desc',
    orderBy: 'poid',
    filters: [],
  };
  const defaultAuditFilter = {
    currentPage: 1,
    pageSize: 10,
    order: 'desc',
    orderBy: 'ChargeAuditID',
    filters: [],
  };
  const defaultSbFilter = {
    currentPage: 1,
    pageSize: 10,
    order: 'desc',
    orderBy: 'modifiedDate',
    filters: [],
  };
  const defaultrxManager = {
    currentPage: 1,
    pageSize: 100,
    order: 'desc',
    orderBy: 'modifiedDate',
    filters: [],
  };
const defaultAccumulationsFilter = {
  currentPage: 1,
  pageSize: 100,
  order: 'desc',
  orderBy: 'modifiedDate',
  filters: [],
};

const defaultcrosswalkQueue = {
  currentPage: 1,
  pageSize: 10,
  order: "desc",
  orderBy: "ModifiedDate",
  filters: [],
};
const defaultcrosswalkAutomapping = {
  currentPage: 1,
  pageSize: 10,
  order: "desc",
  orderBy: "ModifiedDate",
  filters: [],
};
const defaultcrosswalkUnmappedcharge = {
  currentPage: 1,
  pageSize: 10,
  order: "desc",
  orderBy: "ModifiedDate",
  filters: [],
};
const defaultcrosswalkNdc = {
  currentPage: 1,
  pageSize: 10,
  order: "desc",
  orderBy: "ModifiedDate",
  filters: [],
};
const defaultcrosswalk = {
  currentPage: 1,
  pageSize: 10,
  order: "desc",
  orderBy: "ModifiedDate",
  filters: [],
};
  //24-10-2024
  const defaultconfigCoveredEntity = {
    currentPage:1,
    pageSize: 100,
    order: "desc",
    orderBy:"modifiedDate",
    filters: [],
  }
  const defaultconfigPatientType = {
    currentPage:1,
    pageSize: 10,
    order: "desc",
    orderBy:"modifiedDate",
    filters: [],
    isFilterCancel:false
  }
  const defaultconfigPayor = {
    currentPage:1,
    pageSize: 10,
    order: "desc",
    orderBy:"PayorTypeID",
    filters: [],
  }
  const defaultconfigurations = {
    currentPage:1,
    pageSize: 100,
    order: "desc",
    orderBy:"modifiedDate",
    filters: [],
  }

 export const defaultAddCoveredEntity = {
  currentPage: 1,
  pageSize: 10,
  order: 'desc',
  orderBy: 'ce',
  filters: [],
};
// const defaultconfigPatientType = {
//   currentPage:1,
//   pageSize: 100,
//   order: "desc",
//   orderBy:"modifiedDate",
//   filters: [],
// };
const defaultconfigPayorType = {
  currentPage:1,
  pageSize: 10,
  order: "desc",
  orderBy:"modifiedDate",
  filters: [],
};
const defaultAccmulatorType = {
  currentPage:1,
  pageSize: 100,
  order: "desc",
  orderBy:"modifiedDate",
  filters: [],
};
const defaultOrdering = {
  currentPage:1,
  pageSize: 100,
  order: "desc",
  orderBy:"modifiedDate",
  filters: [],
};
const defaultLocation = {
  currentPage:1,
  pageSize: 100,
  order: "desc",
  orderBy:"modifiedDate",
  filters: [],
};
const defaultRule = {
  currentPage:1,
  pageSize: 10,
  order: "desc",
  orderBy:"modifiedDate",
  filters: [],
};
const defaultInventoryFilter = {
  currentPage: 1,
  pageSize: 10,
  order: 'desc',
  orderBy: 'modifiedDate',
  filters: [],
};
const defaultDrugCataFilter = {
  currentPage: 1,
  pageSize: 10,
  order: "desc",
  orderBy: "WholesalerID",
  filters: [],
};

const defaultDrugWholeSalerFilter = {
  currentPage: 1,
  pageSize: 10,
  order: "desc",
  orderBy: "modifiedDate",
  filters: [],
};

const defaultDrugExcluFilter = {
  currentPage: 1,
  pageSize: 10,
  order: "desc",
  orderBy: "modifiedDate",
  filters: [],
};

const defaultStates = {
  //24-10-2024
  searchOrder: {
    hasFilterd: false,
    search: cloneDeep(defaultPOFilter),
    coveredEntities: [],
    accumulations: [],
    coveredEntity: {},
    accumulation: {},
    searchTerms: {
      coveredEntityIDs: {},
      accumulationIDs: {},
      accountType: {},
      orderStatusId: '',
      actButton: "All",
      poNumber: '',
      invoiceNumber: '',
      showClaimID: '',
      hospitalId :''
    }
  },
  dashboard: {
    hasFilterd: false,
    search: [],
    coveredEntities: [],
    accmulations: [],
    searchTerms: {
      coveredEntityIDs: {},
      accmulationsIDs: {},
      startDate: "",
      endDate:"",
    },
  },
  searchAudit: {
    hasFilterd: false,
    search: cloneDeep(defaultAuditFilter),
    coveredEntities: [],
    accumulations: [],
    coveredEntity: {},
    accumulation: {},
    searchTerms: {
      coveredEntityIDs: {},
      accumulationIDs: {},
      accountType: 0,
      startDate: '',
      endDate: '',
      count: null,
      percent: null,
      auditCriteria: null,
      criteriaSelected: null,
    }
  },
  rxManager:{
    hasFilterd: false,
    search: cloneDeep(defaultrxManager),
    coveredEntities: [],
    coveredEntity: {},
    accumulations: [],
    accumulation: {},
    dateRange: {},
    //mappedStatus:[],
    searchTerms: {
      coveredEntityIDs: {},
      accumulationIDs: {},
      startDate: '',
      endDate: '',
     encounter: '',
     acunttype: 'All'
    },
  },
  sbreports: {
    hasFilterd: false,
    search: cloneDeep(defaultSbFilter),
    coveredEntities: [],
    coveredEntity: {},
    accumulations: [],
    accumulation: {},
    dateRange: {},
    //mappedStatus:[],
    searchTerms: {
      coveredEntityIDs: {},
      accumulationIDs: {},
      startDate: '',
      endDate: '',
      acunttype : 1000,
      report : '',
      dateRangeID: 1,
      statusTypeSelected:0,
      status : null,
    },
  },
  poReconciliation: {
    hasFilterd: false,
    search: cloneDeep(defaultPOFilter),
    coveredEntities: [],
    accumulations: [],
    coveredEntity: {},
    accumulation: {},
    searchTerms: {
      coveredEntityIDs: {},
      accumulationIDs: {},
      accountTypeId: {},
      orderStatusId: {},
      poNumber: '',
      showClaimID: '',
    }
  },
  configurations: {
    hasFilterd: false,
    search: cloneDeep(defaultconfigurations),
    coveredEntities: [],
    
    coveredEntity: {},
    searchTerms: {
      coveredEntityIDs: {},
    }
  },
  reviewOrder: {
    hasFilterd: false,
    search: cloneDeep(defaultPOFilter),
    coveredEntities: [],
    accumulations: [],
    coveredEntity: {},
    accumulation: {},
    searchTerms: {
      coveredEntityIDs: {},
      accumulationIDs: {},
      poDate: '',
      wholesalerId: '',
      sourcePO: '',
      showClaimID: '',
    }
  },
  viewPOReconciliation: {
    hasFilterd: false,
    search: cloneDeep(defaultPOReconFilter),
    coveredEntities: [],
    accumulations: [],
    coveredEntity: {},
    accumulation: {},
    searchTerms: {
      coveredEntityIDs: {},
      accumulationIDs: {},
      poDate: '',
      wholesalerId: '',
      sourcePO: '',
      showClaimID: '',
    }
  },
  accumulation: {
    hasFilterd: false,
    search: cloneDeep(defaultAccumulationsFilter),
    coveredEntities: [],
    accumulations: [],
    coveredEntity: {},
    accumulation: {},
    searchTerms: {
      coveredEntityIDs: {},
      accumulationIDs: {},
      ndc: '',
      showClaimID: '',
    },
  },
  crosswalkQueue: {
    hasFilterd: false,
    queuesearch: cloneDeep(defaultcrosswalkQueue),
    coveredEntities: [],
    coveredEntity: {},
    accumulations: [],
    accumulation: {},
    //mappedStatus:[],
    searchTerms: {
      
      coveredEntityIDs: {},
      accumulationIDs: {},
    },
  },
  crosswalkAutomapping: {
    hasFilterd: false,
    automappingsearch: cloneDeep(defaultcrosswalkAutomapping),
    coveredEntities: [],
    coveredEntity: {},
    accumulations: [],
    accumulation: {},
    //mappedStatus:[],
    searchTerms: {
      
      coveredEntityIDs: {},
      accumulationIDs: {},
    },
  },
   crosswalkUnmappedcharge: {
    hasFilterd: false,
    unmappedchargesearch: cloneDeep(defaultcrosswalkUnmappedcharge),
    coveredEntities: [],
    coveredEntity: {},
    accumulations: [],
    accumulation: {},
    //mappedStatus:[],
    searchTerms: {
      
      coveredEntityIDs: {},
      accumulationIDs: {},
    },
  },
     crosswalkNdc: {
    hasFilterd: false,
    crosswalkNdcsearch: cloneDeep(defaultcrosswalkNdc),
    coveredEntities: [],
    coveredEntity: {},
    accumulations: [],
    accumulation: {},
    //mappedStatus:[],
    searchTerms: {
      
      coveredEntityIDs: {},
      accumulationIDs: {},
    },
  },
    crosswalk: {
    hasFilterd: false,
    crosswalksearch: cloneDeep(defaultcrosswalk),
    coveredEntities: [],
    coveredEntity: {},
    accumulations: [],
    accumulation: {},
    //mappedStatus:[],
    searchTerms: {
      
      coveredEntityIDs: {},
      accumulationIDs: {},
    },
  },
  
  //24-10-2024
  //25-10-2024
  configCoveredEntity:{
    hasFilterd: false,
    search:cloneDeep(defaultconfigCoveredEntity),
  },
  configPatientType:{
    hasFilterd: false,
    search:cloneDeep(defaultconfigPatientType),
  },
  configPayor:{
    hasFilterd: false,
    search:cloneDeep(defaultconfigPayor),
  },
   configPayorType: {
    hasFilterd: false,
    search: cloneDeep(defaultconfigPayor),
    coveredEntities: [],
    coveredEntity: {},
    //mappedStatus:[],
    searchTerms: {
      coveredEntityIDs: {},
    },
  },
   configAddPayorType: {
    hasFilterd: false,
    //search: cloneDeep(defaultSbFilter),
    coveredEntities: [],
    coveredEntity: {},
    //mappedStatus:[],
    searchTerms: {
      coveredEntityIDs: [],
    },
  },
  drugCatalog: {
    hasFilterd: false,
    search: cloneDeep(defaultDrugCataFilter),
    coveredEntities: [],
    accumulations: [],
    coveredEntity: {},
    accumulation: {},
    searchTerms: {
      coveredEntityIDs: {},
      accumulationIDs: {},
      hospitalDD: {},
    }
  },
  drugExclusion: {
    hasFilterd: false,
    search: cloneDeep(defaultDrugExcluFilter),
    coveredEntities: [],
    accumulations: [],
    coveredEntity: {},
    accumulation: {},
    searchTerms: {
      coveredEntityIDs: {},
      accumulationIDs: {},
      // hospitalDD: "",
    }
  },
  drugWholeSaler:{
    hasFilterd: false,
    search:cloneDeep(defaultDrugWholeSalerFilter),
    coveredEntities: [],
    accumulations: [],
    coveredEntity: {},
    accumulation: {},
    searchTerms: {
      coveredEntityIDs: {},
      accumulationIDs: {},
      accountTypeId: {},
    }
  },


  //25-10-2024

  claimsManager: {
    hasFilterd: false,
    search: cloneDeep(defaultClaimsFilter),
    pharmacies: [],
    patients: [],
    claimStatus: {},
    coveredEntity: {},
    pharmacy: {},
    statusname: {},
    searchPatientTerm: '',
    patient: '',
    provider: '',
    searchTerms: {
      coveredEntityID: '',
      pharmacyID: '',
      patientID: '',
      rxNumber: '',
      providerID: '',
      providerFirstName: '',
      startDate: '',
      endDate: '',
      claimStatusID: '',
      pharmacyIds: {},
      claimStatusIds: {}
    },
  },

  inventory: {
    hasFilterd: false,
    search: cloneDeep(defaultInventoryFilter),
    coveredEntities: [],
    accumulations: [],
    coveredEntity: {},
    accumulation: {},
    searchTerms: {
      coveredEntityIDs: {},
      accumulationIDs: {},
      ndc: '',
      showClaimID: '',
    },

    addcoveredentity: {
      hasFilterd: false,
      search: cloneDeep(defaultAddCoveredEntity),
      coveredEntities: [],
      chainPharmacies: [],
      pharmacies: [],
      coveredEntity: {},
      chainPharmacy: {},
      wholesalers: {},
      searchTerms: {
        coveredEntityIDs: {},
        chainPharmacyIds: {},
        pharmacyIds: {},
        poNumber: '',
        invoiceNumber: '',
        showClaimID: '',
        orderStatusId: '',
        wholesalerId: '',
        startDate: '',
        endDate: '',
        claimTypeId: ''
      }
    }
  },
  // configPatientType:{
  //   hasFilterd: false,
  //   search:cloneDeep(defaultconfigPatientType),
  // },
  // configPayorType:{
  //   hasFilterd: false,
  //   search:cloneDeep(defaultconfigPayorType),
  // },
  configAccumulatorType:{
    hasFilterd: false,
    search:cloneDeep(defaultAccmulatorType),

  },
  configOrderingType:{
    hasFilterd: false,
    search:cloneDeep(defaultOrdering),

  },
  configLocationType:{
    hasFilterd: false,
    search:cloneDeep(defaultLocation),

  },
  configRlueType:{
    hasFilterd: false,
    search:cloneDeep(defaultRule),

  }

};

const initialStates = {
  loading: false,
  searchOrder: cloneDeep(defaultStates.searchOrder),
  dashboard:cloneDeep(defaultStates.dashboard),
  poReconciliation: cloneDeep(defaultStates.poReconciliation),
  reviewOrder: cloneDeep(defaultStates.reviewOrder),
  viewPOReconciliation: cloneDeep(defaultStates.viewPOReconciliation),
  accumulation: cloneDeep(defaultStates.accumulation),
  claimsManager: cloneDeep(defaultStates.claimsManager),
  inventory: cloneDeep(defaultStates.inventory),
  drugCatalog: cloneDeep(defaultStates.drugCatalog),
  drugExclusion: cloneDeep(defaultStates.drugExclusion),
  drugWholeSaler:cloneDeep(defaultStates.drugWholeSaler),
  crosswalkUnmappedcharge: cloneDeep(defaultStates.crosswalkUnmappedcharge),
  crosswalkQueue: cloneDeep(defaultStates.crosswalkQueue),
  crosswalkAutomapping:cloneDeep(defaultStates.crosswalkAutomapping),
crosswalkNdc:cloneDeep(defaultStates.crosswalkNdc),
crosswalk:cloneDeep(defaultStates.crosswalk),
  configCoveredEntity: cloneDeep(defaultStates.configCoveredEntity),
//  configPatientType: cloneDeep(defaultStates.configPatientType),
  configPayor: cloneDeep(defaultStates.configPayor),
  configPatientType: cloneDeep(defaultStates.configPatientType),
  configPayorType:cloneDeep(defaultStates.configPayorType),
  configAddPayorType:cloneDeep(defaultStates.configAddPayorType),
  configAccumulatorType:cloneDeep(defaultStates.configAccumulatorType),
  configOrderingType:cloneDeep(defaultStates.configOrderingType),
  configLocationType:cloneDeep(defaultStates.configLocationType),
  configRlueType:cloneDeep(defaultStates.configRlueType),
  searchAudit: cloneDeep(defaultStates.searchAudit),
  sbreports: cloneDeep(defaultStates.sbreports),
  configurations:cloneDeep(defaultStates.configurations),
  rxManager:cloneDeep(defaultStates.rxManager)


};

export { initialStates, defaultStates };
